<script>
    import { checkPassword } from "../helpers/validators";
    import { required, minLength, numeric, email, sameAs } from 'vuelidate/lib/validators'

    export default {
        validations: {
            login: {
                id: {
                    required,
                    numeric
                },
                password: {
                    required
                }
            },
            resetPassword: {
              email: {
                  required,
                  email
              }
            },
            confirm: {
                password: {
                    required
                },
                password_confirmation: {
                    required,
                    sameAs: sameAs('password')
                }
            },
            clientLogin: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            },
            newMember: {
              first_name: {
                  required,
              },
              last_name: {
                  required,
              },
              email: {
                  required,
                  email
              },
              gender: {
                  required,
              }
            },
            clientSignUp: {
                firstName: {
                    required,
                },
                lastName: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                studio_id: {
                    required,
                },
                password: {
                    required,
                    checkPassword
                },
                passwordConfirm: {
                    required,
                    checkPassword,
                    sameAs: sameAs('password')
                },
                gdpr_agreement: {
                    required
                },
                terms_agreement: {
                    required
                }
            },
            test: {
                required,
                minLength: minLength(6),
            },
            testPassword: {
                required,
                minLength: minLength(6),
            },
            testSimpleInput: {
                required,
                minLength: minLength(6),
            }
        }
    }
</script>